<app-group
	[baseClass]="'mt-5'"
	[groupConfig]="groupConfig"
>
	<ng-container class="group-main-content">
		<ng-content></ng-content>
	</ng-container>
</app-group>


